import { setDefaultOptions }  from "date-fns";
import { enUS } from "date-fns/locale";
import { oneDay } from "../utils/constants";
export function setup() {
    setDefaultOptions({locale: enUS});
}

export const createDatesFromTimeFrame = (timeFrame = 1, futureDateParam = null) => {
    const futureDate = futureDateParam || new Date();
    const pastDate = new Date(futureDate.getTime() - oneDay * timeFrame);

    return {
        futureDate,
        pastDate,
    };
};
